import { msg } from '@lingui/core/macro';

export const SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_TITLE = msg`Subscription cannot be deactivated`;
export const SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_ACTIVE_REQUIREMENTS = msg`This subscription has active learning requirements associated with it.`;
export const SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_LINK = msg`Go to Learning Requirements`;
